import { UrlUtil } from "../../util/UrlUtil";

type UpdateListener = (x: number) => void;

export class EvergreenCounterService {
	private static readonly _instances: EvergreenCounterService[] = [];

	private readonly _listeners: UpdateListener[] = [];

	private _started = false;

	private constructor(
		private readonly _endpoint: string,
		private readonly _milliseconds: number
	) {}

	public static getOrCreateInstance(
		endpoint: string,
		milliseconds: number = 600000 // ten minutes
	): EvergreenCounterService {
		if (!endpoint) {
			throw new Error("Invalid endpoint");
		}

		const lc = endpoint.toLowerCase();
		const existing = EvergreenCounterService._instances.find(
			i => i._endpoint === lc
		);

		if (existing) {
			return existing;
		}

		const created = new EvergreenCounterService(endpoint, milliseconds);
		EvergreenCounterService._instances.push(created);

		return created;
	}

	public addUpdateListener(callback: UpdateListener): void {
		if (callback) {
			this._listeners.push(callback);
		}
	}

	public start(): void {
		if (this._started) {
			return;
		}

		this._started = true;

		this.poll();
	}

	private poll(): void {
		const rawEndpoint = this._endpoint;
		const withCacheBuster = UrlUtil.setUniqueQueryString(rawEndpoint);
		const ajax = $.ajax(withCacheBuster);

		const updates = ajax.then(result => {
			const parsed = Math.floor(Number(result));
			if (!isNaN(parsed)) {
				this.update(parsed);
			}
		});

		// tslint:disable:no-floating-promises
		// Justification: Polling mechanism goes on forever, always floats.
		updates.then(() => {
			window.setTimeout(() => this.poll(), this._milliseconds);
		});
	}

	private update(result: number): void {
		const errors: Error[] = [];

		this._listeners.forEach(listener => {
			try {
				listener(result);
			} catch (ex) {
				errors.push(ex as Error);
			}
		});

		if (errors) {
			errors.forEach(ex => console.error(ex));
		}
	}
}
